import { createPageHead } from 'drf-react/seo/seo'

export const SITE_URL = 'https://htmleditor.io'
export const SITE_NAME = 'HTML Editor'
export const HOME_PAGE_TITLE =
  'Online HTML Editor: Free Online WYSIWYG HTML Editor'
export const SITE_DESCRIPTION =
  'Free online HTML Editor with an intuitive WYSIWYG Editor that outputs clean W3C compliant HTML code that you can copy-paste into any project.'

export const pageHead = createPageHead({
  siteUrl: SITE_URL,
  titleSuffix: SITE_NAME,
  homePageTitle: HOME_PAGE_TITLE
})
